<template>
    <div class="rp-helpdesk-conversation-message-order" @click="$emit('click')">
        <div class="rp-helpdesk-conversation-message-box-order" :class="cardType">
            <div class="header" :class="[{'view-btn-enabled': showViewButton}, cardType]">
				<div class="store-logo">
					<img v-if="!brandLogo || brandLogo != 'NA'" src="https://messenger.richpanel.com/img/shopping-bag.svg" height="30"/>
					<img v-else-if="!errorLoadingBrandLogo" :src="brandLogoURL" height="30" @error="errorLoadingBrandLogo=true"/>
					<img v-else src="https://messenger.richpanel.com/img/shopping-bag.svg" height="30"/>
				</div>
				<div class="order-info">
					<div class="order-header">
						<div class="order-number">
							<span class="label">{{ $t("orderList.orderLabel") }}</span>
							<span class="number">{{ orderDisplayName }}</span>
							<div class="ordered-date" v-if="cardType==='listing' || orderData.createdAt">{{ orderCreatedAt }}</div>
						</div>
						<div 
							:style="
								{
									textAlign: !showViewButton && cardType != 'message' ? 'end' : 'left'
								}"
							class="rp-messenger-order-status"
						>
							<span class="tag" :style="getColor">
								{{ getOrderStatus(orderData.fulfillmentStatus ||  orderData.status) }}
							</span>
						</div>
					</div>
					<div class="order-body" v-if="!showTopHeaderOnly">
						<div class="o-section">
							<div class="o-title">
								{{ orderData.amount.label}}
							</div>
							<div class="o-value" :title="orderData.amount.value">
								{{ currencySymbol }}{{ abbreviateNumber(orderData.amount.value, 'price')}}
							</div>
						</div>
						<div class="o-section">
							<div class="o-title">
								{{ $t("orderList.items" ) }}
							</div>
							<div class="o-value" :title="orderData.qty.value">
								{{ abbreviateNumber(orderData.qty.value, 'items') }}
							</div>
						</div>
					</div>
				</div>
        	</div>
			<div>
				<div class="order-view-button" v-if="showViewButton">
					<i class="el-icon-arrow-right" />
				</div>
			</div>
			<div class="selected-items" v-if="orderData.selectedItems.items.length && !showTopHeaderOnly">
				<div class="selected-items__header">
					{{ $t("orderList.selectedItems") }}
				</div>
				<div class="selected-items__item" 
					v-for="selectedItem in orderData.selectedItems.items"
					:key="selectedItem.itemId"
					>
					<div class="selected-items__item____label">
						{{ selectedItem.itemLabel }} {{ selectedItem.selectedCount ? 'X ' + selectedItem.selectedCount : '' }}
					</div>
					<div class="selected-items__item____value" :title="selectedItem.calculatedPrice">
						{{ currencySymbol }}{{ abbreviateNumber(selectedItem.calculatedPrice, 'items') }}
					</div>
				</div>
			</div>
    	</div>
    </div>
</template>

<script>
const orderMessageStruct = {
    storeLogoURL: 'https://s3-us-west-2.amazonaws.com/app.richpanel.com/static/images/datasources/f9be7eab-7be9-4d19-ab7f-c0b818b408f4-logo.png',
    storeURL: '',
    orderLabel: 'Order',
    orderId: '#347526',
	status: 'Delivered',
	currency: '$',
    amount: {
        label: 'AMT',
        value: 4,
    },
    qty: {
        label: 'ITEMS',
        value: '2',
        measureLabel: ' '
    },
    selectedItems: {
        header: 'Selected items',
        items: [
            {
                itemId: '1',
                itemLabel: 'Salted Peanut 150g Pouch', 
                calculatedPrice: 2,
                selectedCount: 6,
            }
        ]
    },
}
import { COMMAN_IMG_URL, abbreviateNumber } from '../../constants'
import {
	DateTime
} from 'luxon'
export default {

    props: {

        message: {
            type: Object,
            required: true
		},
		cardType: {
			type: String,
			default: 'message',
		},

		showTopHeaderOnly: {
			type: Boolean,
			default: false,
		},

		showViewButton: {
			type: Boolean,
			default: false,
		}

    },
    data(){
        return {
			errorLoadingBrandLogo: false,
			abbreviateNumber,
		};
    },
	methods: {
		getOrderStatus(statusValue) {
			if(!statusValue) {
				return '';
			}
			let orderStatus = this.$t(`orderStatuses.${statusValue.toLowerCase()}`);
			return orderStatus === `orderStatuses.${statusValue.toLowerCase()}` ? statusValue : orderStatus
		}
	},
    computed: {
        orderData() {
            try {
                return JSON.parse(this.message.mediaValue);
            } catch(e) {
                return orderMessageStruct;
            }
		},
		orderDisplayName() {
			if(this.orderData && this.orderData.orderName) {
				return this.orderData.orderName
			}
			return "#"+this.orderData.orderId
		},
		getColor() {
			if(this.orderData.fulfillmentStatus || this.orderData.status) {
				const orderStatus = this.orderData.fulfillmentStatus || this.orderData.status.toLowerCase();
				if (["processing", "processed", "shipped", "delivered", "packed", "confirmed" ].includes(orderStatus)) 
                {
                    return {
                        background: "#d3e4fd",
                    }   
                } else if(["on-hold", "pending"].includes(orderStatus)) {
                    return {
                        background: "#ffefd5",
                    }
                } else if (["cancelled", "failed"].includes(orderStatus)) {
                    return {
                        background: "#ffd5df",
                    }
                } else if(["fulfilled", "completed"].includes(orderStatus)) {
                    return {
                        background: "#c8f5ba",
                    }
                } else {
                    return {
                        background: "#EAEAEC",
                    }
                }
			}
			
		},
		brandLogoURL() {
			return COMMAN_IMG_URL + this.brandLogo;
		},
		brandLogo() {
			if(this.$root.configuration.brandData) return this.$root.configuration.brandData.brandLogo;
			else return 'NA';
		},
		currencySymbol() {
			return this.$root.configuration.currency.symbol;
		},
		orderCreatedAt() {
			return DateTime.fromMillis(this.orderData.createdAt).setLocale(this.$root.defaultLanguage).toFormat('DD')
		}
    }

}

</script>

<style lang="scss">
    .rp-helpdesk-conversation-message-box-order {
        display: inline-block;
		.order-view-button {
			align-self: center;
			font-size: 40px;
			margin-right: -10px;
		}
        &.listing {
			width: 100%;
			display: flex;
			flex-direction: row;
			align-items: center;
		}
		&.message {
			border-radius: 7px;
			border: 1px solid #cccccc;
			width: 500px;
			max-width: 90%;
		}
        .header {
			&.listing {
				width: 100%;
			}
			&.view-btn-enabled {
				width: calc(100% - 30px)
			}
			&.message {
				padding: 1rem;
			}
			display: flex;
            align-items: flex-start;
			font-size: 15px;
			@include for-size(desktop-up){
				font-size: 19px;
			}
			justify-content: flex-start;
			.store-logo {
				height: 32px;
				width: 26px;
				margin-right: 15px;
				@include for-size(desktop-up){
					margin-right: 20px;
				}
				img {
					margin-top: 2px;
					@include for-size(desktop-up){
						height: 40px;
					}
				}
				@include for-size(desktop-up){
					height: 40px;
					width: 33px;
				}
			}
			.order-info {
				width: calc(100% - 41px);
				.order-header {
					display: flex;
					align-items: flex-start;
					flex: 1;
					justify-content: space-between;
					color: #333333;
					font-weight: 500;
					.order-number {
						overflow: hidden;
						text-overflow: ellipsis;
						white-space: nowrap;
						line-height: normal;
						max-width: 45%;

						.label {
							margin-right: 0.3rem;
						}
						.ordered-date {
							color: #a4a4a4;
							font-size: 11.5px;
							@include for-size(desktop-up){
								font-size: 15.5px;
							}
							font-weight: 400;
							line-height: normal;
						}
					}
				}
				.order-body {
					display: flex;
					align-items: flex-start;
					justify-content: space-between;
					margin-top: 0.8rem;
					.o-section {
						width: 45%;
						text-align: left;
						.o-title {
							font-size: 15px;
							text-transform: uppercase;
							@include for-size(desktop-up){
								font-size: 19px;
							}
							color: #999999;
						}
						.o-value {
							font-size: 22px;
							color:  #4d4d4d;
							@include for-size(desktop-up){
								font-size: 26px;
							}
						}
					}
					.order-view-button {
						align-self: center;
						font-size: 40px;
					}
				}
			}
			.rp-messenger-order-status {
				width: 45%;
				line-height: 2;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				line-height: normal;
				.tag{
					padding: 3px 9px;
					border-radius: 3px;
					text-transform: capitalize;
					color: #333333;
					font-weight: 500;
					line-height: 25px;
					font-size: 14px;
					text-align: center;
				}
			}
            
		}
		.selected-items {
			border-top: 1px solid #cccccc; 
			padding: 1rem;
			text-align: left;
			background: #f7f7f7;
			border-bottom-right-radius: 7px;
    		border-bottom-left-radius: 7px;
			.selected-items__header {
				color: #333;
				font-size: 16px;
				line-height: 26px;
				@include for-size(desktop-up){
					font-size: 20px;
				}
			}
			.selected-items__item {
				display: flex;
				align-items: flex-start;
				justify-content: space-between;
				line-height: 20px;
				padding-top: 10px;
				padding-bottom: 10px;
				+.selected-items__item {
					border-top: 1px dotted #d2c8c8;
				}
				&.selected-items__item:first-child {
					padding-top: 3px;
				}
				&.selected-items__item:last-child {
					padding-bottom: 0px;
				}
				
				.selected-items__item____label,.selected-items__item____value {
					color: #666666;
					font-size: 13px;
					margin-right: 10px;
					@include for-size(desktop-up){
						font-size: 16px;
					}
				}
				.selected-items__item____value {
					margin-right: 0px;
				}

				
			}
		}
        &.from-operator {
            text-align: right;
        }

        &.from-customer {
            text-align: left;
        }
    }

</style>
